module.exports = __webpack_public_path__ + "img/k-grey-woman-back.1d539498.jpg";